import React from 'react';
import PropTypes from 'prop-types';
import { arrayOf, func, string, shape, bool, oneOf } from 'prop-types';
import {
  AdditionalInformation,
  HorizontalRule,
  InputsWrapper,
  InputGroup
} from './MultiSelect.styled';

const MultiSelect = ({
  onClick,
  options,
  type,
  srMessage,
  position = 'left',
  additionalInformationNode = null
}) => {
  return (
    <InputsWrapper position={position}>
      <legend className="visually-hidden">{srMessage}</legend>
      {options.map(option => {
        const { id, checked, label, name, value, disabled } = option;
        return (
          <InputGroup key={id}>
            <input
              onClick={onClick}
              type={type}
              id={id}
              value={value}
              checked={checked}
              name={name}
              disabled={!!disabled}
              readOnly
            />
            <label htmlFor={id}>{label}</label>
          </InputGroup>
        );
      })}
      {additionalInformationNode ? (
        <AdditionalInformation>
          <HorizontalRule />
          {additionalInformationNode}
        </AdditionalInformation>
      ) : (
        ''
      )}
    </InputsWrapper>
  );
};

MultiSelect.propTypes = {
  onClick: func,
  options: arrayOf(
    shape({
      id: string,
      label: string,
      checked: bool
    })
  ).isRequired,
  type: oneOf(['checkbox', 'radio']),
  srMessage: string,
  id: string,
  onChecked: func,
  position: string,
  additionalInformationNode: PropTypes.element
};

export default MultiSelect;
